import AuthService from "../login/auth.service";
import { cardInformer } from "../../components/generico/utils/UrlAPI";
import axios from "axios";
class ConfiguracionTarjetaService {
    async getParametrosTarjeta(data) {
        var config = {
            method: "post",
            url: cardInformer + "cardinformer/obtener-parametros-tarjeta",
            data,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken(),
            },
        };
        return await axios(config);
    }
    async setParametrosTarjeta(data) {
        var config = {
            method: "post",
            url: cardInformer + "cardinformer/cargar-parametros-tarjeta",
            data,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken(),
            },
        };
        return await axios(config);
    }
}
export default new ConfiguracionTarjetaService();